import initialStepValidation from "reducers/work-order/close-step-validation/initialStepValidation";
import { isSkinnyInstallType } from "../../../utils/helper";

export default (state, orderId) => {
  let currentValidation =
    state.getIn([
      "workOrderDetails",
      orderId,
      "orderClose",
      "details",
      "stepValidation",
    ]) || initialStepValidation;

  const workOrderDetails = state.getIn(["workOrderDetails", orderId]);

  const currentStatus = workOrderDetails.getIn([
    "orderClose",
    "details",
    "closeOrderRequest",
    "orderStatus",
  ]);

  const serviceTypeId = state.getIn([
    "workOrderDetails",
    orderId,
    "schedulingSystemDetails",
    "details",
    "serviceOrderInfoV2",
    "serviceTypeId",
  ]);

  const insideHomeValue = workOrderDetails.getIn([
    "orderClose",
    "details",
    "closeOrderRequest",
    "inHomeAccessNeededToComplete",
  ]);

  if (
    [true, false].indexOf(insideHomeValue) >= 0 ||
    currentStatus === "NoAccess" ||
    isSkinnyInstallType(serviceTypeId)
  ) {
    currentValidation = currentValidation
      .setIn(["insideHomeAccess", "isValid"], true)
      .setIn(["insideHomeAccess", "message"], null);
  }

  return currentValidation;
};



// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/insideHomeAccessValidator.js